/**
 * エクセルファイルの読み込みに使用するオプション関連をまとめる
 */

import { ExportExcelParseOption } from '../appLogic/interfaces/exportExcel';
import { ExcelParseOption } from './translateExcel';

/**
 * 2023-06-24時点の転記エクセルオプションデータ
 * 会社ごとに分ける場合は、***OutputExcelPageNamesのような形で作れるように作成
 * TODO: TranslateとExportで分類分けできるようにする (画面表示のため)
 */
export const defaultOutputExcelPageNames: [[string, string], ExcelParseOption][] = [
  [
    ['ハンファPP', 'A3'],
    {
      separateYmd: {
        startCell: 'AD1',
        separateCount: 5,
      },
      fileName: '',
      sheetName: 'ハンファPP',
      ignoreRow: [],
    },
  ],
  [
    ['SABIC', 'A3'],
    {
      separateYmd: {
        startCell: 'AD1',
        separateCount: 5,
      },
      fileName: '',
      sheetName: 'SABIC',
      ignoreRow: [],
    },
  ],
  [
    ['ﾃﾞﾙﾍﾟｯﾄ', 'A3'],
    {
      separateYmd: {
        startCell: 'AE1',
        separateCount: 5,
      },
      fileName: '',
      sheetName: 'ﾃﾞﾙﾍﾟｯﾄ',
      ignoreRow: [],
    },
  ],
  [
    ['ﾕｰﾋﾟﾛﾝ', 'A3'],
    {
      separateYmd: {
        startCell: 'AD1',
        separateCount: 5,
      },
      fileName: '',
      sheetName: 'ﾕｰﾋﾟﾛﾝ',
      ignoreRow: [],
    },
  ],
  [
    ['ﾉﾊﾞﾃﾞｭﾗﾝ', 'A3'],
    {
      separateYmd: {
        startCell: 'AD1',
        separateCount: 5,
      },
      fileName: '',
      sheetName: 'ﾉﾊﾞﾃﾞｭﾗﾝ',
      ignoreRow: [],
    },
  ],
  [
    ['実績&内示', 'A2'],
    {
      separateYmd: {
        startCell: 'K1',
        separateCount: 1,
      },
      fileName: '',
      sheetName: '実績&内示',
      ignoreRow: [],
    },
  ],
  [
    ['在庫管理表', 'A3'],
    {
      separateYmd: {
        startCell: 'AD1',
        separateCount: 5,
      },
      fileName: '',
      sheetName: '在庫管理表',
      ignoreRow: [],
    },
  ],
  [
    ['在庫ALL', 'A3'],
    {
      separateYmd: {
        startCell: 'AF1',
        separateCount: 5,
      },
      fileName: '',
      sheetName: '在庫ALL',
      ignoreRow: [],
    },
  ],
  [
    ['確定発注出力', 'A2'],
    {
      separateYmd: {
        startCell: 'A2',
        separateCount: 1,
      },
      fileName: '',
      sheetName: '確定発注出力',
      ignoreRow: [],
    },
  ],
  [
    ['取込転記用', 'A4'],
    {
      separateYmd: {
        startCell: 'A4',
        separateCount: 1,
      },
      fileName: '',
      sheetName: '取込転記用',
      ignoreRow: [],
    },
  ],
];

/* TODO:リファクタ対象 */
/**
 * 2023-10-23時点のファイル出力する仕入先内示エクセルオプションデータ
 * 会社ごとに分ける場合は、***InventoryExcelPageNamesのような形で作れるように作成
 * TODO: 出力する際に、新規で列を追加する必要があるため、追加列の列名データを登録する必要があると考えている
 */
export const defaultExportExcelPageNames: [[string, string], ExportExcelParseOption][] = [
  [
    ['実績&内示', 'A2'],
    {
      separateYmd: {
        startCell: 'K1',
        separateCount: 2,
      },
      fileName: '',
      sheetName: '実績&内示',
      ignoreRow: [],
      valueStartCell: 'K3',
      addColumnName: [
        { colName: '内示', isUpdateCalender: true },
        { colName: '内示内訳', isUpdateCalender: true },
      ],
    },
  ],
];

/**
 * 2023-06-24時点の内示エクセルオプションデータ
 * 会社ごとに分ける場合は、***AnnounceExcelPageNamesのような形で作れるように作成
 *
 */
export const defaultAnnounceExcelParseOption: ExcelParseOption = {
  separateYmd: {
    startCell: 'N14',
    separateCount: 1,
  },
  fileName: '',
  sheetName: '',
  ignoreRow: [],
};

/**
 * 2023-06-24時点の販売実績エクセルオプションデータ
 * 会社ごとに分ける場合は、***AnnounceExcelPageNamesのような形で作れるように作成
 *
 */
export const defaultSalesResultExcelParseOption: ExcelParseOption = {
  separateYmd: {
    startCell: 'AV5',
    separateCount: 16,
  },
  fileName: '',
  sheetName: '',
  ignoreRow: [],
};

/**
 * 2023-06-24時点の入荷エクセルオプションデータ
 * 会社ごとに分ける場合は、***ArrivalExcelPageNamesのような形で作れるように作成
 *
 */
export const defaultArrivalExcelParseOption: ExcelParseOption = {
  separateYmd: {
    startCell: 'AK5',
    separateCount: 6,
  },
  fileName: '',
  sheetName: '',
  ignoreRow: [],
};

/**
 * 2023-06-24時点の在庫エクセルオプションデータ
 * 会社ごとに分ける場合は、***InventoryExcelPageNamesのような形で作れるように作成
 *
 */
export const defaultInventoryExcelParseOption: ExcelParseOption = {
  separateYmd: {
    startCell: '',
    separateCount: -1,
  },
  fileName: '',
  sheetName: '',
  ignoreRow: [],
};

/**
 * 指定した会社？の転記エクセルのオプションデータにファイルネームを追加して返す関数
 * @param fileName - ファイル名
 * @param parseOption - parseExcelObjectsで色々やるためのオプション
 * @returns 返り値
 */
export const addFileNameToOutputExcelOption = <T extends ExcelParseOption | ExportExcelParseOption>(
  fileName: string,
  parseOption: [[string, string], T][]
): [[string, string], T][] => {
  parseOption.forEach((option) => {
    option[1].fileName = fileName;
  });
  return parseOption;
};

/**
 * 指定した会社？の入力エクセルのオプションデータにファイルネームを追加して返す関数
 * @param fileName - ファイル名
 * @param sheetName - シート名
 * @param parseOption - parseExcelObjectsで色々やるためのオプション
 * @returns 返り値
 */
export const addFileNameToInputExcelOption = (fileName: string, sheetName: string, parseOption: ExcelParseOption): ExcelParseOption => {
  parseOption.fileName = fileName;
  parseOption.sheetName = sheetName;
  return parseOption;
};
